// Estado de un Derecho Minero. Los valores DEBEN coincidir con el enum del backend
// shared/MineTrace.Shared/Enums/MiningRightStatus.cs (Vigente=1, Extinto=2,
// EnTramite=3, Suspendido=4). Antes el front tenía 2 y 3 al revés: un derecho "en
// trámite" se guardaba como Extinto y viceversa.
export const MiningRightStatusId = {
  Vigente: 1,
  Extinto: 2,
  EnTramite: 3,
  Suspendido: 4,
} as const

/** Traduce el "estado" textual del REINFO / INGEMMET al id del enum del backend. */
export function miningRightStatusFromEstado(estado: string | null | undefined): number {
  if (!estado) return MiningRightStatusId.Vigente
  const lower = estado.toLowerCase()
  if (lower.includes('vigente')) return MiningRightStatusId.Vigente
  if (lower.includes('tramite') || lower.includes('trámite')) return MiningRightStatusId.EnTramite
  if (lower.includes('extin')) return MiningRightStatusId.Extinto
  if (lower.includes('suspendido')) return MiningRightStatusId.Suspendido
  return MiningRightStatusId.Vigente
}
